import { Observable } from 'rxjs';

import ClassifierValue from '../interfaces/classifierValue';
import Paginate from '../interfaces/paginate';
import Warehouse from '../interfaces/warehouse';
import { HttpClient, ListParams } from './http-client';

export class WarehouseService extends HttpClient {
  index(farmId: string, params: ListParams): Observable<Paginate<Warehouse>> {
    return this.get<Paginate<Warehouse>>(
      `/api/farms/${farmId}/warehouses`,
      params
    );
  }

  store(farmId: string, warehouse: Warehouse): Observable<Warehouse> {
    return this.post<Warehouse>(`/api/farms/${farmId}/warehouses`, warehouse);
  }

  show(farmId: string, id: string): Observable<Warehouse> {
    return this.get<Warehouse>(`/api/farms/${farmId}/warehouses/${id}`);
  }

  update(
    farmId: string,
    id: string,
    warehouse: Warehouse
  ): Observable<Warehouse> {
    return this.put<Warehouse>(
      `/api/farms/${farmId}/warehouses/${id}`,
      warehouse
    );
  }

  typesOfWarehouses(
    farmId: string,
    id?: string
  ): Observable<ClassifierValue[]> {
    return this.get<ClassifierValue[]>(
      `/api/farms/${farmId}/warehouses/types-of-warehouses${id ? `/${id}` : ''}`
    );
  }
}
